<template>
    <b-modal
        id="ModalCreateFiche"
        title="Créer une fiche"
        size="lg"
        header-bg-variant="kalkin-1"
        header-text-variant="light"
        no-close-on-backdrop
        no-close-on-esc
        scrollable
    >
        <FormFiche
            ref="formFicheCreate"
            :sit="sit"
            :format="format"
            :project="project"
        />
        <template #modal-footer="{ cancel }">
            <b-button variant="outline-secondary" @click="cancel()">
                Annuler
            </b-button>
            <b-button variant="kalkin-2" @click="save">
                Enregistrer et quitter
            </b-button>
        </template>
    </b-modal>
</template>
<script>
import FormFiche from "./FormFiche";
export default {
    components: {
        FormFiche,
    },

    props: {
        sit: { type: String, required: true },
        format: { type: Object, required: true },
        project: { type: Object, required: true },
    },

    methods: {
        async save() {
            if (await this.$refs.formFicheCreate.save()) {
                this.$bvModal.hide("ModalCreateFiche");
                this.$emit("saved");
            }
        },
    },
};
</script>
